const URLHelper = require('utils/URLHelper.js');
let ImpressService = require('../../services/ImpressService');

module.exports = {
    props: ['index', 'isLoggedToDashboard'],
    data: function() {
        ImpressService.onEnter('dashboard', () => {
            window.focus();
        });
        return {
            analyticsDemoUrl: URLHelper.getDemoAnalyticsUrl()
        };
    },
    template: require('./dashboard.html')
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/dashboard/dashboard.js
// module id = 92
// module chunks = 0